import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime)
dayjs.extend(isLeapYear)

dayjs.locale('tr')

function capitalize(s) {
  return s[0].toUpperCase() + s.slice(1);
}

export default function formatDate(date) {
  return date ? capitalize(dayjs().to(date)) : '--'
}

